export default __webpack_public_path__ + "static/media/phase2-bg.ccb5fe24.svg";